const getPopUpType = state => state.foams.drawersPopUp.type;
const getPopUpFoamData = state => state.foams.drawersPopUp.foam;
const getPopUpTargetDrawer = state => state.foams.drawersPopUp.drawer;

export default {
  getPopUpFoamData,
  getPopUpTargetDrawer,
  getPopUpType
};
